import './whatsapp_media_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappAudioMessageContent extends Monitoring.Models.SocialContents.WhatsappMediaMessageContent


  getMainText: ->
    ""
